import React from 'react';
import AboutUs from '../component/aboutUs/AboutUs';
import { Helmet } from 'react-helmet';
import ComponenetHeader from '../component/common/ComponenetHeader';

const AboutPage = () => {

  return (
    <>
      <Helmet>
        <link rel="canonical" href="/about"/>
        <title>About Us | Breakdowninc Truck Repair Services </title>
        <meta name="keywords" content="Breakdowninc,Heavy Duty Truck Parts,Commercial Semi Truck Repair,Semi Truck Repair,Truck Service,Semi Repair,Parts Locations,Closest Service Available,Closest Truck Service,Repair Vendors Specials"/>
        <meta name="description" content="Breakdowninc Truck Service has over 30,000 services that you can easily find by searching your location. We provide Heavy Duty Truck Parts, Commercial Semi Truck Repair locations." />
        <meta property="og:title" content="About Us | Breakdowninc Truck Repair Services" />
        <meta property="og:description" content="Breakdowninc Truck Service has over 30,000 services that you can easily find by searching your location. We provide Heavy Duty Truck Parts, Commercial Semi Truck Repair locations." />
      </Helmet>
      <ComponenetHeader
        name={'About Us'}
      />
      <AboutUs />
    </>
  );
};

export default AboutPage;